import { BigFormRow, FormRow, FormSection } from 'framework/ui/layout';
import { EmployeePhotoUploaderInput } from 'domain/shared/employee';
import { FC } from 'react';
import { DateInput, GenderRadioButtonGroup, NameInput, TextInput } from 'framework/form';
import { EMPLOYEE_TYPES_ALIAS } from 'domain/shared/employee';

const MainInfoSection: FC = () => {
  return (
    <FormSection title="Main information">
      <BigFormRow>
        <EmployeePhotoUploaderInput label="Worker photos" source="extendedInformation.photosIds" />
      </BigFormRow>
      <NameInput label="Local name" source="nameLocal" middleNameLabel="Patronymic name" />
      <NameInput label="Latin name" source="nameEn" middleNameLabel="Middle name" />
      <FormRow>
        <DateInput source="extendedInformation.dateOfBirth" label="Date of birth" />
        <GenderRadioButtonGroup source="gender" label="Gender" className="gender-radio-button-group" />
        <TextInput
          label="Syberry email"
          source="workingEmail"
          isVisible={data => data.employeeType === EMPLOYEE_TYPES_ALIAS.CONTRACTOR}
        />
      </FormRow>
    </FormSection>
  );
};

export { MainInfoSection };
